import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Armazon } from './components/Armazon';
import { Cargando } from './components/ui';
import { useSesion } from './lib/sesion';
import type { Rol } from './lib/tipos';
import { Acceso } from './pages/Acceso';
import { Panel } from './pages/Panel';
import { Solicitudes } from './pages/Solicitudes';
import { SolicitudDetalle } from './pages/SolicitudDetalle';
import { NuevaSolicitud } from './pages/NuevaSolicitud';
import { Agenda } from './pages/Agenda';
import { Cocina } from './pages/Cocina';
import { Disponibilidad } from './pages/Disponibilidad';
import { Clientes } from './pages/Clientes';
import { Cuenta } from './pages/Cuenta';
import { Usuarios } from './pages/admin/Usuarios';
import { Comerciales } from './pages/admin/Comerciales';
import { Importacion } from './pages/admin/Importacion';
import { Configuracion } from './pages/admin/Configuracion';
import { Integraciones } from './pages/admin/Integraciones';
import { Estadisticas } from './pages/admin/Estadisticas';
import { Auditoria } from './pages/admin/Auditoria';
import { Clave } from './pages/Clave';

function Privada({ roles, children }: { roles?: Rol[]; children: React.ReactNode }) {
  const { usuario, cargando } = useSesion();
  const ubicacion = useLocation();

  if (cargando) return <Cargando texto="Comprobando la sesión…" />;
  if (!usuario) return <Navigate to="/entrar" state={{ desde: ubicacion.pathname }} replace />;
  if (roles && !roles.includes(usuario.role)) return <Navigate to="/" replace />;
  return <>{children}</>;
}

export function App() {
  const { usuario, cargando } = useSesion();

  return (
    <Routes>
      <Route
        path="/entrar"
        element={cargando ? <Cargando /> : usuario ? <Navigate to="/" replace /> : <Acceso />}
      />
      <Route path="/clave/:token" element={<Clave />} />

      <Route
        element={
          <Privada>
            <Armazon />
          </Privada>
        }
      >
        <Route path="/" element={<Panel />} />
        <Route path="/solicitudes" element={<Solicitudes />} />
        <Route
          path="/solicitudes/nueva"
          element={
            <Privada roles={['SALESPERSON', 'ADMIN']}>
              <NuevaSolicitud />
            </Privada>
          }
        />
        <Route path="/solicitudes/:id" element={<SolicitudDetalle />} />
        <Route path="/agenda" element={<Agenda />} />
        <Route
          path="/cocina"
          element={
            <Privada roles={['COOK', 'SALES_MANAGER', 'ADMIN']}>
              <Cocina />
            </Privada>
          }
        />
        <Route
          path="/indisponibilidad"
          element={
            <Privada roles={['COOK', 'SALES_MANAGER', 'ADMIN']}>
              <Disponibilidad />
            </Privada>
          }
        />
        <Route
          path="/clientes"
          element={
            <Privada roles={['SALESPERSON', 'SALES_MANAGER', 'ADMIN']}>
              <Clientes />
            </Privada>
          }
        />
        <Route path="/cuenta" element={<Cuenta />} />

        <Route path="/admin/estadisticas" element={<Privada roles={['ADMIN']}><Estadisticas /></Privada>} />
        <Route
          path="/admin/usuarios"
          element={
            <Privada roles={['ADMIN']}>
              <Usuarios />
            </Privada>
          }
        />
        <Route path="/admin/comerciales" element={<Privada roles={['ADMIN']}><Comerciales /></Privada>} />
        <Route
          path="/admin/importacion"
          element={
            <Privada roles={['ADMIN']}>
              <Importacion />
            </Privada>
          }
        />
        <Route
          path="/admin/configuracion"
          element={
            <Privada roles={['ADMIN']}>
              <Configuracion />
            </Privada>
          }
        />
        <Route
          path="/admin/integraciones"
          element={
            <Privada roles={['ADMIN']}>
              <Integraciones />
            </Privada>
          }
        />
        <Route
          path="/admin/auditoria"
          element={
            <Privada roles={['ADMIN']}>
              <Auditoria />
            </Privada>
          }
        />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
